import React from 'react';
import CiberCsirtcontent from '../components/CiberCsirtContent';
import Footer from '../components/footer';

const CiberCsirtpage = () => {
  return (
    <div className="Ciberseg">
       
          <CiberCsirtcontent />
          <Footer />
    </div>
  );
}

export default CiberCsirtpage;